import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-2 tw-block tw-text-xs" }, " Plays on stage before the event begins and between sessions, if no other sessions are live ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs tw-font-medium" }, "Select Video", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioSpinner = _resolveComponent("StudioSpinner")!
  const _component_PlusCircle = _resolveComponent("PlusCircle")!
  const _component_VideoLibraryListItem = _resolveComponent("VideoLibraryListItem")!
  const _component_VideoLibraryDialog = _resolveComponent("VideoLibraryDialog")!
  const _component_ModuleWrapper = _resolveComponent("ModuleWrapper")!

  return (_openBlock(), _createBlock(_component_ModuleWrapper, {
    moduleId: _ctx.moduleId,
    title: "Buffer Video",
    onInitializeData: _ctx.initializeData
  }, {
    main: _withCtx(() => [
      _hoisted_1,
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_StudioSpinner, {
            key: 0,
            coverContainer: false,
            size: "xsmall"
          }))
        : (!_ctx.selectedVideoAsset)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "tw-flex tw-items-center tw-text-deep-orange-600 hover:tw-text-deep-orange-500",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showVideoLibraryDialog = true))
            }, [
              _createVNode(_component_PlusCircle, { class: "tw-mr-1 tw-h-6 tw-w-6" }),
              _hoisted_2
            ]))
          : (_openBlock(), _createBlock(_component_VideoLibraryListItem, {
              key: 2,
              visibleActions: {
          openPreview: true,
          rename: true,
          remove: true
        },
              alwaysShowActions: "",
              videoAsset: _ctx.selectedVideoAsset,
              onRemove: _ctx.handleDeselectVideoAsset,
              onRenameSuccess: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleRenameSuccess($event)))
            }, null, 8, ["videoAsset", "onRemove"])),
      (_ctx.showVideoLibraryDialog)
        ? (_openBlock(), _createBlock(_component_VideoLibraryDialog, {
            key: 3,
            title: "Select Buffer Video",
            maxSelections: 1,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showVideoLibraryDialog = false)),
            onSelectVideos: _ctx.handleSelectVideos
          }, null, 8, ["onSelectVideos"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["moduleId", "onInitializeData"]))
}